import {ChangeDetectorRef, Component, Inject, NgZone, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from "@angular/material/chips";

export interface ConfirmDialogData {
  title: string;
  description: string;
  withExtraTags: boolean;
  extraTags: string[];
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private ngZone: NgZone,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) { }

  ngOnInit(): void {
    this.data.extraTags = this.data.withExtraTags ? [] : null;
  }

  onNoClick(): void {
    this.ngZone.run(() => {
      this.dialogRef.close();
    });
  }

  success(data: any) {
    this.ngZone.run(() => {
      this.dialogRef.close(data);
    });
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add
    if (value) {
      this.data.extraTags.push(value);
    }

    // Clear the input value
    event.input.value = "";
  }

  remove(tag: string): void {
    const index = this.data.extraTags.indexOf(tag);
    if (index >= 0) {
      this.data.extraTags.splice(index, 1);
    }
  }

}
